import { IState } from '../../store';

export const selectFavoriteMotivationShows = (state: IState) => state.favoriteMotivation.isShows;
